import React from "react";
import videobg from "../../../videos/home.mp4";
import { Link } from "react-scroll";
import { scrollDuration } from "../../../config/commonConfig";
import {
  HeroCta,
  HeroHeadline,
  HeroTagline,
  HeroTypewriter,
  ProfileImage,
} from "../../shared/IntroHeroContent";

const StandardMenuVideoBgIntro = () => {
  return (
    <section id="home">
      <div className="hero-wrap">
        <div className="hero-mask opacity-8 bg-primary" />
        <div className="player hero-bg ">
          <video
            src={videobg}
            autoPlay
            muted
            loop
            style={{
              width: "100%",
              height: "100vh",
              minHeight: "100%",
              objectFit: "cover",
            }}
          ></video>
        </div>
        <div className="hero-content d-flex fullscreen-with-header">
          <div className="container my-auto py-5 py-lg-0">
            <div className="row py-4">
              <div className="col-lg-7 text-center text-lg-start align-self-center order-1 order-lg-0">
                <HeroHeadline />
                <HeroTypewriter className="text-21 fw-600 text-uppercase mb-0 ms-n1" />
                <HeroTagline />
                <HeroCta />
              </div>
              <div className="col-lg-5 text-center align-self-center mb-4 mb-lg-0 order-0 order-lg-1">
                <ProfileImage wrapperClassName="bg-light rounded-pill d-inline-block p-3 shadow-lg wow zoomIn" />
              </div>
            </div>
          </div>
          <Link
            className="scroll-down-arrow text-dark smooth-scroll"
            smooth="easeInOutQuint"
            duration={scrollDuration}
            style={{ cursor: "pointer" }}
            to="about"
          >
            <span className="animated">
              <i className="fas fa-arrow-down" />
            </span>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default StandardMenuVideoBgIntro;
